
import { useState } from 'react';

export default function AnchorApplicationSection() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const copyWechat = async () => {
    try {
      await navigator.clipboard.writeText('TeaMaster2024');
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (err) {
      console.error('复制失败:', err);
    }
  };

  return (
    <section id="application" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 lg:px-16 xl:px-24">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            开启合作之旅
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            加入我们的主播合作计划，共同开创茶叶直播销售的新篇章
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* 左侧内容 */}
          <div>
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                  <i className="ri-user-star-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">专业团队支持</h3>
                  <p className="text-gray-600">专业的茶叶知识培训团队，助您成为茶叶带货专家</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                  <i className="ri-money-dollar-circle-line text-2xl text-green-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">丰厚佣金回报</h3>
                  <p className="text-gray-600">高达30%的销售佣金，多重奖励机制等您来拿</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
                  <i className="ri-trophy-line text-2xl text-purple-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">品牌共建机会</h3>
                  <p className="text-gray-600">与知名茶叶品牌深度合作，共同打造个人IP</p>
                </div>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <button 
                onClick={() => setIsContactModalOpen(true)}
                className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                立即申请合作
              </button>
              <button 
                onClick={() => setIsContactModalOpen(true)}
                className="border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-question-line mr-2"></i>
                咨询合作详情
              </button>
            </div>
          </div>

          {/* 右侧图片 */}
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/3703698965dc26524ab985f6d35047c3.jpg"
              alt="主播合作"
              className="w-full h-[500px] object-cover object-top rounded-2xl shadow-2xl"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
          </div>
        </div>
      </div>

      {/* 联系弹窗 */}
      {isContactModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 relative">
            <button
              onClick={() => setIsContactModalOpen(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
            
            <div className="text-center mb-6">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">联系我们</h3>
              <p className="text-gray-600">欢迎咨询合作详情</p>
            </div>

            <div className="space-y-6">
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                    <i className="ri-phone-line text-blue-600"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">客服热线</p>
                    <p className="font-semibold text-gray-900">400-888-6666</p>
                  </div>
                </div>
                <a
                  href="tel:400-888-6666"
                  className="text-blue-600 hover:text-blue-700 transition-colors cursor-pointer"
                >
                  <i className="ri-phone-fill text-xl"></i>
                </a>
              </div>

              <div className="p-4 bg-gray-50 rounded-xl">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                      <i className="ri-wechat-line text-green-600"></i>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">微信号</p>
                      <p className="font-semibold text-gray-900">TeaMaster2024</p>
                    </div>
                  </div>
                  <button
                    onClick={copyWechat}
                    className={`px-3 py-1 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                      isCopied 
                        ? 'bg-green-100 text-green-700' 
                        : 'bg-blue-100 text-blue-700 hover:bg-blue-200'
                    }`}
                  >
                    {isCopied ? (
                      <>
                        <i className="ri-check-line mr-1"></i>
                        已复制
                      </>
                    ) : (
                      <>
                        <i className="ri-file-copy-line mr-1"></i>
                        复制
                      </>
                    )}
                  </button>
                </div>
                <div className="text-xs text-gray-5 bg-white p-3 rounded-lg border-l-4 border-yellow-400">
                  <i className="ri-information-line mr-1 text-yellow-600"></i>
                  添加微信时请注明来意和账号，如"某某某账号寻求普洱茶货盘定制"
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
